import React, { useEffect, useState } from "react";
import { Highcharts } from "./index";
import HighchartsReact from "highcharts-react-official";
import isEqual from "react-fast-compare";
import {
  setHighChartDeepDive,
  setHighChartRightClick,
} from "../../../../redux/actions/HighChart";
import { useDispatch, useSelector } from "react-redux";
import { callNotification } from "../../../../redux/constants";
const HighChartrender = ({
  opData,
  clickcondition,
  id,
  rightClickCondition,
  dashboard,
  pptDownloadStatus,
  pdfDownloadStatus,
  single,
  type,
}) => {
  const dispatch = useDispatch();
  const personalizationSettingsObj = useSelector(
    (state) => state?.PersonalizationSetting
  );
  const [currentSelectedGraph, setCurrentSelectedGraph] = useState(null);
  const handleClick = (value) => {
    dispatch(setHighChartDeepDive({ data: value, flag: true, id: id }));
  };
  const handleRightClick = (value) => {
    if (personalizationSettingsObj?.isPersonalizationPreviewOpen) {
      callNotification(
        "Actions are not allowed while customizing",
        "info",
        40,
        "personalization-preview-notification personalization-preview-mask",
        true
      );
      return;
    }
    dispatch(setHighChartRightClick({ data: value, flag: true, id: id }));
  };
  useEffect(() => {
    let refreshHandler;
    if (currentSelectedGraph && currentSelectedGraph?.reflow && opData) {
      refreshHandler = setTimeout(() => {
        try {
          // Make sure the container exists and has dimensions before reflowing
          const chart = currentSelectedGraph;
          const container = chart?.renderTo;

          if (
            container &&
            container?.clientHeight > 0 &&
            container?.clientWidth > 0
          ) {
            chart.reflow();
          }
        } catch (e) {
          console.warn("Error during chart reflow:", e);
        }
      }, [1000]);
    }
    return () => {
      refreshHandler && clearTimeout(refreshHandler);
    };
  }, [currentSelectedGraph, opData]);

  const thisCurrentGraph = (chart) => {
    if (chart && chart?.renderTo) {
      setCurrentSelectedGraph(chart);
    }
  };
  return (
    <div>
      {opData && (
        <HighchartsReact
          isPureConfig={true}
          highcharts={Highcharts}
          options={{
            ...opData,
            chart: {
              ...opData?.chart,
              events: {
                ...opData?.chart?.events,
                render: function () {
                  // Ensures chart has proper dimensions after rendering
                  if (
                    this &&
                    this?.renderTo &&
                    this?.renderTo?.clientHeight > 0
                  ) {
                    setTimeout(() => {
                      try {
                        this?.reflow();
                      } catch (e) {
                        console.warn("Error in chart render event:", e);
                      }
                    }, 100);
                  }
                },
              },
            },
            plotOptions: {
              ...opData?.plotOptions,

              series: {
                ...opData?.plotOptions?.series,
                trackByArea: type === "area" ? true : false,
                cursor: "pointer",
                // *** To enable animation in every chart ***
                animation:
                  pptDownloadStatus || pdfDownloadStatus ? false : true,
                // *** to control multiple rendering ***
                // animation: pptDownloadStatus || pdfDownloadStatus
                //   ? false
                //   : dashboard && opData && opData[id]?.count <= 0
                //     ? true
                //     : !dashboard
                //     ? true
                //     : true,
                // *** To disabled animation comment upper code and uncomment this ***
                // animation: false,
                point: {
                  events: {
                    contextmenu: (event) => {
                      rightClickCondition && event.preventDefault();
                      return rightClickCondition && handleRightClick(event);
                    },
                    click: function (e) {
                      // Check if this is a treemap chart
                      if (this?.series?.type === "treemap") {
                        const chart = this?.series?.chart;
                        const series = chart?.series?.find(
                          (s) => s.type === "treemap"
                        );
                        const nodeId = this?.node?.id;

                        // Handle drill-down for non-leaf nodes
                        if (
                          nodeId &&
                          nodeId !== "root" &&
                          !this?.node?.isLeaf &&
                          series &&
                          typeof series?.drillToNode === "function"
                        ) {
                          // Use native treemap drill-down
                          series?.drillToNode(nodeId);
                          return; // Stop here to prevent custom click handling
                        }

                        // Only trigger custom click handler for leaf nodes
                        if (clickcondition && this?.node?.isLeaf) {
                          handleClick(this);
                        }
                      } else {
                        // For all other chart types, use existing behavior
                        if (clickcondition) {
                          handleClick(this);
                        }
                      }
                    },
                  },
                },
              },
            },
          }}
          // allowChartUpdate={!graphLoader ? true : false}
          allowChartUpdate={true}
          callback={thisCurrentGraph}
        />
      )}
    </div>
  );
};

export default React.memo(HighChartrender, isEqual);
